export default __webpack_public_path__ + "static/media/CaslonIonic-Regular.f2ed8b77.otf";